import { render, staticRenderFns } from "./FinishCommission.vue?vue&type=template&id=13c601ac&"
import script from "./FinishCommission.vue?vue&type=script&lang=js&"
export * from "./FinishCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports